module.exports = __webpack_public_path__ + "static/img/2.f9cb088.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/zh/2.png
// module id = p1Oe
// module chunks = 0